import { Flame, CalendarCheck, Activity, Lock, Sparkles } from "lucide-react";

export const ProgressPanel = ({ progress }) => {
  if (!progress) return null;
  const stats = [
    { icon: Flame, label: "Day streak", value: progress.streak, color: "#F5C842" },
    { icon: CalendarCheck, label: "Days practiced", value: progress.days_practiced, color: "#2DD4BF" },
    { icon: Activity, label: "Total practices", value: progress.total, color: "#A78BFA" },
  ];
  return (
    <div data-testid="progress-panel" className="rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-md p-7">
      <h3 className="font-head font-700 text-xl text-slate-50 mb-6">Your Journey</h3>
      <div className="grid grid-cols-3 gap-4 mb-6">
        {stats.map((s) => {
          const Icon = s.icon;
          return (
            <div key={s.label} className="text-center">
              <Icon className="w-6 h-6 mx-auto mb-2" style={{ color: s.color }} />
              <p className="font-head font-900 text-3xl text-slate-50" data-testid={`stat-${s.label.split(" ")[0].toLowerCase()}`}>{s.value}</p>
              <p className="text-xs text-slate-500 mt-1">{s.label}</p>
            </div>
          );
        })}
      </div>

      {progress.insights_unlocked ? (
        progress.insight ? (
          <div className="rounded-xl border border-[#F5C842]/30 bg-[#F5C842]/5 p-4 flex items-start gap-3" data-testid="gold-insight">
            <Sparkles className="w-5 h-5 text-[#F5C842] mt-0.5 shrink-0" />
            <p className="text-sm text-amber-100/90">{progress.insight}</p>
          </div>
        ) : (
          <p className="text-xs text-slate-500">Complete a practice to unlock your personalized Gold insight.</p>
        )
      ) : (
        <div className="rounded-xl border border-white/10 p-4 flex items-center gap-3 text-slate-400" data-testid="insight-locked">
          <Lock className="w-4 h-4" />
          <p className="text-xs">Personalized journey insights unlock with Gold.</p>
        </div>
      )}
    </div>
  );
};
